import React from 'react';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';
import { downloadICSFile, getGoogleCalendarUrl, getOutlookCalendarUrl } from '../../utils/calendarUtils';

const CalendarIntegration = ({ interview }) => {
  return (
    <div className="mt-4 border border-border rounded-lg p-4">
      <h3 className="font-medium mb-3 flex items-center gap-2">
        <Icon name="Calendar" size={18} />
        <span>Add to Calendar</span>
      </h3>
      
      <div className="flex flex-wrap gap-2">
        <Button
          variant="outline"
          size="sm"
          onClick={() => window.open(getGoogleCalendarUrl(interview), '_blank')}
          className="flex items-center gap-1.5"
        >
          <Icon name="Calendar" size={16} />
          <span>Google Calendar</span>
        </Button>
        
        <Button
          variant="outline"
          size="sm"
          onClick={() => window.open(getOutlookCalendarUrl(interview), '_blank')}
          className="flex items-center gap-1.5"
        >
          <Icon name="Calendar" size={16} />
          <span>Outlook</span>
        </Button>
        
        <Button
          variant="outline"
          size="sm"
          onClick={() => downloadICSFile(interview)}
          className="flex items-center gap-1.5"
        >
          <Icon name="Download" size={16} />
          <span>Download .ics</span>
        </Button>
      </div>
    </div>
  );
};

export default CalendarIntegration;